<template>
  <div>
    <h3 class="title">Select your Google Ads ID</h3>
    <div class="adwords-box">
      <template v-for="(value, key) in ids" :key="key">
        <adwords-id-btn
          :item="getItem(key,value)"
          :multiple="is_multiple"
          :active="isSelected( getItem(key,value) )"
          @selected="handleSelected" />
      </template>
    </div>

    <div v-if="is_multiple" class="row text-center">
      <p v-if="selected === false" class="text-danger">Need to select an Adwords ID</p>
      <p v-if="error" class="text-danger">Please select a Google Ads account</p>
    </div>

    <div class="row text-center">
      <p v-html="selected_text" />
    </div>
    <step-navigation-buttons @next="handleNext" @prev="handlePrev"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { sendReportDataLayer, shallowEqual } from "@/utils";
import AdwordsIdBtn from "@/components/global/AdwordsIdBtn";
import StepNavigationButtons from "@/components/global/StepNavigationButtons";

export default {
  name: "ChooseAdwordsAccount",
  props: {
    ids: {
      type: Object,
      required: true,
    }
  },
  components: {
    AdwordsIdBtn,
    StepNavigationButtons,
  },
  data:() => ({
    selected: null,
    error: null,
  }),
  computed: {
    is_multiple() {
      return Object.keys(this.ids).map(Number).length > 1;
    },

    selected_text() {
      if (!this.is_multiple) return '';
      return `Selected: <strong>${ this.selected_name }</strong>`;
    },

    selected_name() {
      if ( !this.selected ) return 'None';
      const defaultName = 'Google Ads account';
      return Object.values( this.selected )[0] || defaultName;
    }
  },
  methods: {
    ...mapActions(['SEND_ADWORDS_ID']),

    handleNext() {
      if ( this.is_multiple && !this.selected ) {
        this.error = true;
        return;
      }

      this.error = null;
      this.sendID();
      this.sendEvent();
      this.$router.push({ name: 'More Information' });
    },

    handlePrev() {
      this.$router.push({ name: 'Connect Google' });
    },

    handleSelected(e) {
      this.selected = e;
    },

    getItem(key, value) {
      return { [key] : value };
    },

    isSelected(item) {
      if ( !this.selected ) return false;
      return shallowEqual(item, this.selected);
    },

    sendID() {
      if ( this.is_multiple && !this.selected ) {
          this.selected = false;
          return false;
      }
      else if ( !this.is_multiple ) {
        this.selected = this.ids;
      }

      // continue with selected
      const id = Object.keys(this.selected)[0];
      this.SEND_ADWORDS_ID(id);
      return true;
    },

    sendEvent() {
      sendReportDataLayer({
        report_step: 3,
        report_step_name: 'select_account',
        google_ads_accounts_count: Object.keys(this.ids).map(Number).length,
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";

.adwords-box {
  margin-top: 40px;
  width: 373px;
  max-width: 100%;
  max-height: 272px;
  overflow-y: scroll;
  margin-left: auto;
  margin-right: auto;

  /* width */
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: $scrollbarTrack;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $scrollbarThumb;
    border-radius: 5px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: darken($scrollbarThumb, 10%);
  }

  //
  button:not(:last-child) {
    margin-bottom: 12px;
  }
}

p {
  margin-top: 24px;
  margin-bottom: 24px;
}
</style>